/**
 * Canonicalize a note/template section heading for cross-spelling matching.
 *
 * The pinned cross-repo pipeline (TS twin of the Python `canonicalize_heading`
 * at the ml-scribe validation seam; both repos assert the SAME vector table so
 * a drift is a test failure):
 *   1. Collapse every whitespace run to one space, then trim both ends.
 *   2. If the result ends with `:`, strip that ONE colon, then re-trim the end.
 *   3. Lowercase with Unicode default lowercasing — NOT `casefold`, which has no
 *      JS twin (`ß` → `ss` drift).
 * No NFKC / Unicode normalization here — that is `normalizeLabel`'s separate job
 * (AX labels, `copilot/mapping.ts`).
 */
export const canonicalizeHeading = (heading: string): string => {
  let out = heading.replace(/\s+/g, ' ').trim();
  if (out.endsWith(':')) out = out.slice(0, -1).trimEnd();
  return out.toLowerCase();
};
